import apiTool from './index';

const GET_MARKETS_URL = 'markets/?no_page';
const GET_CLIENT_MARKETS_URL = 'clients/<pk>/markets/?no_page';
const UPDATE_MARKET = 'clients/<pk>/markets/';

export default {
  getMarkets() {
    return apiTool.get(GET_MARKETS_URL);
  },
  getClientMarkets(payload) {
    return apiTool.get(GET_CLIENT_MARKETS_URL.replace('<pk>', payload));
  },
  updateMarket(payload) {
    return apiTool.put(UPDATE_MARKET.replace('<pk>', payload.pk), payload.data);
  }
};
